/** What the server has to say about a document, ranked by how much it matters. */
import type { Finding, FindingLevel } from '@/api/easykitInkooporder';

const STYLE: Record<FindingLevel, { box: string; label: string }> = {
  refuse: { box: 'border-red-300 bg-red-50 text-red-900', label: 'Geblokkeerd' },
  warn: { box: 'border-amber-300 bg-amber-50 text-amber-900', label: 'Let op' },
  suggest: { box: 'border-sky-300 bg-sky-50 text-sky-900', label: 'Suggestie' },
  applied: { box: 'border-violet-300 bg-violet-50 text-violet-900', label: 'Aangepast' },
};

export function InkooporderFindings({ findings, stale }: { findings: Finding[]; stale: boolean }) {
  if (findings.length === 0) {
    return (
      <div className="rounded-lg border border-emerald-300 bg-emerald-50 text-emerald-900 px-4 py-3 text-sm">
        Dit document is volledig ingelezen. Geen opmerkingen.
      </div>
    );
  }
  return (
    <div className="space-y-2">
      {stale && (
        <p className="text-xs text-td-muted">
          Je hebt iets aangepast — deze opmerkingen zijn van vóór je wijziging en worden opnieuw
          gecontroleerd bij het importeren.
        </p>
      )}
      <ul className="space-y-2">
        {findings.map((finding, i) => {
          const style = STYLE[finding.level];
          return (
            <li
              key={`${finding.code}-${finding.articleNumber ?? i}`}
              className={`rounded-lg border px-4 py-3 text-sm ${style.box}`}
            >
              <span className="font-bold">{style.label}</span>
              <span className="mx-2 opacity-40">·</span>
              {finding.message}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
